import React, { useEffect, useState } from 'react';
import { ActivityIndicator, ScrollView, TextInput, View } from "react-native";
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import Colors from "../../constants/Colorsv2";
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import PostReadCard from '../../screens/socialScreens/SocialComponentsv2/PostReadCard';
import { social_createPost, social_getPodcastEpisodeById, social_getPostById, social_updatePost } from '../../store/actionsv1/social';
import { PublicPlayerProps } from '../../store/types/auth_svc';
import { PodcastEpisodeProps, PostProps, TagProps } from '../../store/types/soc_svc';
import MediaHolder from './components/MediaHolder';
import OrderHolder from './components/OrderHolder';
import PodcastEpisodeCard from './components/PodcastEpisodeCard';
import PostHeader from './components/PostHeader';
import PublishPostModal from './components/PublishPostModal';
import RichTextInput from "./components/RichTextComponents/RichTextInput";
import RTIToolbar from './components/RichTextComponents/RTIToolbar';
import SharedPostHolder from './components/SharedPostHolder';
import URLPreviewCard from './components/URLPreviewCard';
import { post_getEmptyPost } from './helpers/posts';


const MemoPostScreen = ({ route, navigation }:any) => {
    const [ loading, setLoading ] = useState(false);
    const [ post_width, setPostWidth ] = useState(400)
    const [ publish_post_visible, setPublishPostVisible ] = useState(false);
    const [ draft_post, setDraftPost ] = useState<PostProps>(post_getEmptyPost())
    const [ save, setSave ] = useState(false);
    const dispatch = useDispatch()

    const post_from_server:PostProps | undefined = route.params?.type === 'edit' ? useSelector((state:any) => state.social.stored_posts.find(p => p.memo_post_id === route.params?.post_id), (left, right) => left?.memo_post_id == right?.memo_post_id) : undefined
    const shared_post:PostProps | undefined = route.params?.type === 'share' ? useSelector((state:any) => state.social.stored_posts.find(p => p.memo_post_id == route.params?.post_id), (left, right) => left?.memo_post_id == right?.memo_post_id) : undefined
    const player:PublicPlayerProps = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const podcast_episode:PodcastEpisodeProps | undefined = useSelector((state:any) => state.social.viewing_episodes.find(pe => pe.podcast_episode_id == route.params?.post_id), (left, right) => left?.podcast_episode_id == right?.podcast_episode_id)
    
    useEffect(() => {
        if(route.params.type === 'new'){ return setDraftPost(post_getEmptyPost()) } 
        
        if(route.params.type === 'edit' && route.params?.post_id){
            getPostFromServer(route.params.post_id)
        }
        if(route.params.type === 'share' && route.params?.post_id){
            setDraftPost({ ...draft_post, shared_post_id: route.params?.post_id })
            if(!shared_post){ getPostFromServer(route.params.post_id) }   
        }
        if(route.params.type === 'podcast_episode' && route.params?.post_id){
            setDraftPost({ ...draft_post, memo_podcast_episodes: [route.params.post_id] })
            if(!podcast_episode){ dispatch(social_getPodcastEpisodeById(route.params.post_id)) }
        }
        if(route.params.type == 'poll' && route.params?.post_id){
            setDraftPost({ ...draft_post, memo_polls: [route.params.post_id] })
        }
    },[route.params?.type])

    useEffect(() => {
        if(!post_from_server){ return }//No draft post!
        if(player.player_id != post_from_server.player_id){ return }
        if(post_from_server.shared_post_id && !shared_post){ getPostFromServer(post_from_server.shared_post_id, true) }
        return setDraftPost(post_from_server)
    },[post_from_server])


    const getPostFromServer = async(post_id:string) => {
        setLoading(true)
        await dispatch(social_getPostById(post_id))
        setLoading(false)
    }

    const handleSavePost = (status:string) => {
        if(draft_post.player_id && draft_post.player_id != player.player_id){ return }
        setDraftPost({ ...draft_post, status })
        if(status === 'visible'){ return setPublishPostVisible(true) }
        return handlePublish([])
    }

    const handlePublish = async(memo_topics:TagProps[], featured:boolean) => {
        setPublishPostVisible(false)
        if(!draft_post){ return }
        if(!draft_post.memo_post_id && draft_post.status === 'hidden') { return navigation.goBack() }
        setLoading(true)
        if(draft_post.memo_post_id){ await dispatch(social_updatePost({ ...draft_post, memo_topics, featured })) }
        else { await dispatch(social_createPost({ ...draft_post, memo_topics, featured })) }
        setLoading(false)
        return navigation.goBack()
    }

    const handleRemoveUrl = (url:string) => {
        return setDraftPost({ 
            ...draft_post, 
            memo_urls: draft_post.memo_urls.filter(u => u !== url),
            url_metadata: draft_post.url_metadata.filter(md => md?.requestUrl !== url)
        })
    }
    const handleRemoveMedia = (media:any, media_type: 'image'|'video') => {
        if(media_type === 'image'){ return setDraftPost({ ...draft_post, memo_images: draft_post.memo_images.filter(mo => mo.public_id != media.public_id) }) }
        if(media_type === 'video'){ return setDraftPost({ ...draft_post, memo_videos: draft_post.memo_videos.filter(mo => mo.public_id != media.public_id) }) }
        return
    }
    const media_size = draft_post.memo_images.length + draft_post.memo_videos.length
    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            <PostHeader onCancel={() => navigation.goBack()} onSave={(status) => handleSavePost(status)}/>
            <ScrollView style={{ flex:1 }} keyboardShouldPersistTaps='handled'>
                {loading ? 
                <View style={{ justifyContent:'center', alignItems:'center', padding:20 }}>
                    <ActivityIndicator size='large' color={Colors.brand.midnight}/>
                </View>
                :
                <View onLayout={(ev) => {
                    const { width } = ev.nativeEvent.layout;
                    setPostWidth(width)
                }}>
                    <RTIToolbar
                        selected_orders={draft_post.memo_orders}
                        onTagOrders={(orders) => setDraftPost({ ...draft_post, memo_orders: orders })}
                        onImageUpload={(image) => setDraftPost({ ...draft_post, memo_images: draft_post.memo_images.filter(i => i.public_id != image.public_id).concat(image) })} 
                        onVideoUpload={(video) => setDraftPost({ ...draft_post, memo_videos: draft_post.memo_videos.filter(i => i.public_id != video.public_id).concat(video) })} 
                        onLinkCreate={(link, link_preview) => setDraftPost({ 
                            ...draft_post, 
                            memo_urls:draft_post.memo_urls.filter(url => url !== link).concat(link),
                            url_metadata: link_preview ? draft_post.url_metadata.filter(md => md.requestUrl !== link_preview.requestUrl).concat(link_preview) : draft_post.url_metadata
                        })}
                        onToolSelect={(tool) => console.log(tool)}
                        />
                    <View nativeID='post-title' style={{ padding:20, flexDirection:'row', alignItems:'flex-end' }}>
                        <TextInput 
                            value={draft_post.title}
                            style={{ flex:1, fontFamily:'Barlow-Bold', color:Colors.brand.midnight, fontSize:20, padding:5, paddingTop:10 }} 
                            placeholder='Title' 
                            placeholderTextColor={Colors.brand.midnight}
                            onChangeText={(text) => { 
                                if(text.length > 40){ return }//Too long
                                return setDraftPost({ ...draft_post, title: text })
                            }}/>
                        <Text size={14} color={Colors.brand.midnight} style={{ padding:5 }}>{draft_post.title.length}/40</Text>
                    </View>
                    <View style={{ padding:20, paddingTop:0 }}>
                        <RichTextInput 
                            onUpdate={(formatted_body, body) => setDraftPost({ ...draft_post, formatted_body, body })} 
                            formatted_body={draft_post.memo_post_id?draft_post.formatted_body:undefined} 
                            />
                    </View>
                    {draft_post.shared_post_id ?
                    <SharedPostHolder view_mode='edit' navigation={navigation} post_id={draft_post.shared_post_id} onRemovePost={(post_id) => setDraftPost({ ...draft_post, shared_post_id: undefined })}/>
                    :<></>}
                    <View style={{ flexDirection:'row', overflow:'scroll' }}>
                        {draft_post.memo_podcast_episodes && draft_post.memo_podcast_episodes.length > 0 && podcast_episode ?
                        <View style={{ margin:4 }}>
                            <PodcastEpisodeCard hide_description width={post_width / 2} view_mode='view' navigation={navigation} podcast_episode={podcast_episode}/>
                            <TouchableOpacity style={{ position:'absolute', justifyContent:'center', alignItems:'center', borderRadius:100, top:5, right:5, width:20, height:20, backgroundColor:Colors.shades.white }} onPress={() => setDraftPost({ ...draft_post, memo_podcast_episodes: draft_post.memo_podcast_episodes?.filter(pe => pe != podcast_episode.podcast_episode_id) })}>
                                <Icon name='x' type='feather' color={Colors.brand.slate} size={16}/>
                            </TouchableOpacity>
                        </View>
                        :<></>}
                        {media_size > 0 ?
                        <View style={{ margin:4 }}>
                            <MediaHolder width={post_width} view_mode='edit' images={draft_post.memo_images} videos={draft_post.memo_videos} onRemoveMedia={(media, media_type) => handleRemoveMedia(media, media_type)}/>
                        </View>
                        :<></>}
                    </View>

                    {draft_post.memo_urls.length > 0 ?
                    <URLPreviewCard view_mode='edit' hide_image={media_size>0?true:false} onRemoveUrl={(url) => handleRemoveUrl(url)} url={draft_post.memo_urls[0]} url_preview={draft_post.url_metadata[0]} width={post_width}/>
                    :<></>}
                    {draft_post.memo_orders.length > 0 ?
                    <OrderHolder view_mode='edit' width={post_width} order_ids={draft_post.memo_orders} onRemoveOrder={(order_id) => setDraftPost({ ...draft_post, memo_orders: draft_post.memo_orders.filter(o => o != order_id) })}/>
                    :<></>}
                </View>
                }
            </ScrollView> 
            <PublishPostModal onAdd={(topics, featured) => handlePublish(topics, featured)} isVisible={publish_post_visible} closeModal={() => setPublishPostVisible(false)}/>
        </View>
    )
}

export default MemoPostScreen